import { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

const VIDEO_BASE =
  'https://legstorageaccount.blob.core.windows.net/public/assets/video'

/**
 * Returns a function that builds a region-aware video URL.
 * Logic mirrors the landing page: French → MA, English → UAE,
 * Arabic → follows user's country preference.
 */
export default function useVideoPath() {
  const { i18n } = useTranslation()
  const countryPreference = useSelector((s) => s.user.countryPreference)

  const getVideoUrl = useCallback(
    (filename) => {
      const lang = i18n.language
      const isMA =
        Array.isArray(countryPreference) && countryPreference.includes('MA')

      const folder =
        lang === 'fr' ? 'MA' : lang === 'en' ? 'UAE' : isMA ? 'MA' : 'UAE'

      return `${VIDEO_BASE}/${folder}/${filename}`
    },
    [i18n.language, countryPreference],
  )

  return getVideoUrl
}
